<template>
  <div class="CoOrganiser">
    <my_title :content="title.content" :inputStyle="title.style"></my_title>
    <div class="logos">
      <div class="logo" v-for="logo in logos">
        <logo :logo="logo"></logo>
      </div>
    </div>
  </div>
</template>

<script>
 import MyTitle from '@/components/Title.vue';
 import Logo from '@/components/Logo.vue';
 export default {
   name: 'CoOrganiser',
   props: {
   },
   computed: {
     title() {
       return {
         content: '协办单位',
         style: {
           color: 'black',
           background: 'none'
         }
       }
     },
     logos() {
       return this.$store.getters.coorgLogos
     }
   },
   
   components: {
     my_title: MyTitle,
     logo: Logo
   }


 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .CoOrganiser{
   min-height: 33.39vw;
   width: 100vw;
   display: flex;
   box-sizing: border-box;
   padding: 4.2vw 18.6vw;
   flex-direction: column;
   justify-content: space-between;
   align-items:center;
 }
 .logos{
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   justify-content: space-between;
 }
 .logo{
   width:14vw;
 }
</style>
